import { Injectable } from '@angular/core';
import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
import { ReengageAuditGridRequest } from '../models/reengage-audit/reengageAuditGridRequest';
import { ReengageAuditGridResponse } from '../models/reengage-audit/reengageAuditGridResponse';

@Injectable({
  providedIn: 'root',
})
export class ReengageAuditService {
  constructor(private api: NetworkUtilsService) {}

  public getReengageAuditGrid(gridReq: ReengageAuditGridRequest) {
    return this.api.post<ReengageAuditGridResponse>(
      URL_DICT.adminReengageAuditGridUrl,
      gridReq,
    );
  }
}
